import * as yup from 'yup'

export const schemaMergedContract = yup.object().shape({
    contract_id: yup.number().required('contracts.merged.contract_id.required'),
    contract_reason: yup
        .string()
        .required('contracts.merged.contract_reason.required'),
})
